export function formatDurationRussian(durationMinutes: number | null): string {
  if (!durationMinutes) return '';

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  const hoursPart = hours > 0 ? `${hours}ч` : '';
  const minutesPart = minutes > 0 ? `${minutes}м` : '';

  return [hoursPart, minutesPart].filter(Boolean).join(' ');
}
